import Vue from "vue";

export let cashoutEventBus = new Vue({});

export class CashoutEvents {
    static readonly WALLET_FORM_SUBMITTED = "wallet-form-submitted";
    // Fires when user wants to change values on wallet form
    static readonly WALLET_FORM_ADJUST = "wallet-form-adjust";
    // Fires when a user tries to select a sku
    static readonly SKU_SELECT = "sku-select";
    // Fires when an adjustment to cashoutdata is required to select the sku
    static readonly SKU_SELECT_ADJUSTMENT_REQUIRED  = "sku-select-adjustment-required";

    // We've sent a checkout request
    static readonly CHECKOUT_START = "checkout-start";
    // There was a problem with the purchase instruction (CheckoutErrorMode, message)
    static readonly CHECKOUT_ERROR = "checkout-error";
    // There was an unexpected failure (50x code &c)
    static readonly CHECKOUT_FAILURE = "checkout-failure";
    // Checkout succeeded (reference)
    static readonly CHECKOUT_SUCCESS = "checkout-success";

    // Block UI access
    static readonly UI_BLOCK = "ui-block";
    static readonly UI_UNBLOCK = "ui-unblock";
}

export type CheckoutErrorMode = string;

export class CheckoutErrorModes {
    // Constants used for CashoutEvents.CHECKOUT_ERROR events
    static readonly AUTH_EXPIRED = "AUTH_EXPIRED";
    static readonly AUTH_2FA_REQUIRED = "AUTH_2FA_REQUIRED";
    static readonly AUTH_2FA_INVALID = "AUTH_2FA_INVALID";
    static readonly INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS";
    static readonly RATE_NO_LONGER_VALID = "RATE_NO_LONGER_VALID";
    static readonly OVER_DAILY_LIMIT = "OVER_DAILY_LIMIT";
    static readonly ORDER_FAILED = "ORDER_FAILED";
    static readonly VALIDATION_ERROR = "VALIDATION_ERROR";
    static readonly GENERIC_ERROR = "GENERIC_ERROR";
}
